import { ReportHandler } from 'web-vitals';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import TagManager from 'react-gtm-module';
import TelemetryIntitializer from './services/TelemetryIntitializer';

// Get Application Insights instance from your telemetry initializer
const getAppInsights = (): ApplicationInsights | null => {
  try {
    return TelemetryIntitializer.getAppInsights();
  } catch {
    return null;
  }
};

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    const appInsights = getAppInsights();
    
    // Enhanced handler that sends to multiple destinations
    const enhancedHandler = (metric: any) => {
      // Call the original handler if provided
      if (onPerfEntry && onPerfEntry instanceof Function) {
        onPerfEntry(metric);
      }
      
      // Send to Application Insights as custom event
      if (appInsights) {
        appInsights.trackEvent({
          name: `WebVital_${metric.name}`,
          properties: {
            metricName: metric.name,
            value: metric.value,
            rating: metric.rating,
            delta: metric.delta,
            id: metric.id,
            navigationType: metric.navigationType || 'unknown',
            url: window.location.href,
            userAgent: navigator.userAgent
          },
          measurements: {
            [metric.name]: metric.value
          }
        });
        
        console.log(`App Insights: Tracked Web Vital ${metric.name}:`, metric.value);
      } else {
        // Fallback: Use TelemetryIntitializer.trackEvent if direct access fails
        try {
          TelemetryIntitializer.trackEvent({
            name: `WebVital_${metric.name}`,
            properties: {
              metricName: metric.name,
              value: metric.value.toString(),
              rating: metric.rating,
              delta: metric.delta?.toString() || '0',
              id: metric.id,
              navigationType: metric.navigationType || 'unknown',
              url: window.location.href,
              userAgent: navigator.userAgent
            }
          });
          
          console.log(`App Insights (via TelemetryIntitializer): Tracked Web Vital ${metric.name}:`, metric.value);
        } catch (error) {
          console.warn('Failed to track web vital to Application Insights:', error);
        }
      }
      
      // Send to Google Analytics via GTM
      if (typeof window !== 'undefined' && window.dataLayer) {
        const webVitalData = {
          dataLayer: {
            event: 'web_vital',
            metric_name: metric.name,
            metric_value: metric.value,
            metric_rating: metric.rating,
            metric_delta: metric.delta,
            metric_id: metric.id,
            page_path: window.location.pathname
          }
        };
        
        TagManager.dataLayer(webVitalData);
        console.log(`GTM: Tracked Web Vital ${metric.name}:`, metric.value);
      }
    };

    // Collect all Core Web Vitals
    getCLS(enhancedHandler);
    getFID(enhancedHandler);
    getFCP(enhancedHandler);
    getLCP(enhancedHandler);
    getTTFB(enhancedHandler);
  });
};

export default reportWebVitals;
